module.exports = __webpack_public_path__ + "static/media/deleteButton.3cc0ae1f.svg";